{
  "MACROS": {
    "HEADER": "Macro's",
    "DESCRIPTION": "A macro is a set of saved actions that help customer service agents easily complete tasks. The agents can define a set of actions like tagging a conversation with a label, sending an email transcript, updating a custom attribute, etc., and they can run these actions in a single click.",
    "LEARN_MORE": "Learn more about macros",
    "COUNT": "{n} macro | {n} macros",
    "HEADER_BTN_TXT": "Add a new macro",
    "HEADER_BTN_TXT_SAVE": "Save macro",
    "LOADING": "Fetching macros",
    "SEARCH_PLACEHOLDER": "Search macros...",
    "NO_RESULTS": "No macros found matching your search",
    "ERROR": "Something went wrong. Please try again",
    "ORDER_INFO": "Macros will run in the order you add your actions. You can rearrange them by dragging them by the handle beside each node.",
    "ADD": {
      "FORM": {
        "NAME": {
          "LABEL": "Macro name",
          "PLACEHOLDER": "Enter a name for your macro",
          "ERROR": "Name is required for creating a macro"
        },
        "ACTIONS": {
          "LABEL": "Acties"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Macro added successfully",
        "ERROR_MESSAGE": "Unable to create macro, Please try again later"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "NAME": "Naam",
        "CREATED BY": "Aangemaakt door",
        "LAST_UPDATED_BY": "Last updated by",
        "VISIBILITY": "Zichtbaarheid",
        "ACTIONS": "Acties"
      },
      "404": "No macros found"
    },
    "DELETE": {
      "TOOLTIP": "Delete macro",
      "CONFIRM": {
        "MESSAGE": "Weet u zeker dat u wilt verwijderen ",
        "YES": "Ja, verwijderen",
        "NO": "Nee"
      },
      "API": {
        "SUCCESS_MESSAGE": "Macro deleted successfully",
        "ERROR_MESSAGE": "There was an error deleting the macro. Please try again later"
      }
    },
    "VIEW": {
      "TOOLTIP": "View macro"
    },
    "EDIT": {
      "TOOLTIP": "Edit macro",
      "API": {
        "SUCCESS_MESSAGE": "Macro updated successfully",
        "ERROR_MESSAGE": "Could not update Macro, Please try again later"
      }
    },
    "EDITOR": {
      "START_FLOW": "Start Flow",
      "END_FLOW": "End Flow",
      "LOADING": "Fetching macro",
      "ADD_BTN_TOOLTIP": "Add new action",
      "DELETE_BTN_TOOLTIP": "Delete Action",
      "VISIBILITY": {
        "LABEL": "Macro Visibility",
        "GLOBAL": {
          "LABEL": "Public",
          "DESCRIPTION": "This macro is available publicly for all agents in this account.",
          "CREATE_DISABLED_DESCRIPTION": "Only administrators can create public macros.",
          "EDIT_DISABLED_DESCRIPTION": "Only administrators can edit public macros."
        },
        "PERSONAL": {
          "LABEL": "Private",
          "DESCRIPTION": "This macro will be private to you and not be available to others."
        }
      }
    },
    "EXECUTE": {
      "BUTTON_TOOLTIP": "Execute",
      "PREVIEW": "Preview Macro",
      "EXECUTED_SUCCESSFULLY": "Macro executed successfully"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Attribute key is required",
      "FILTER_OPERATOR_REQUIRED": "Filter operator is required",
      "VALUE_REQUIRED": "Waarde is vereist",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Value must be between 1 and 998",
      "ACTION_PARAMETERS_REQUIRED": "Action parameters are required",
      "ATLEAST_ONE_CONDITION_REQUIRED": "At least one condition is required",
      "ATLEAST_ONE_ACTION_REQUIRED": "At least one action is required"
    },
    "ACTIONS": {
      "ASSIGN_TEAM": "Assign a Team",
      "ASSIGN_AGENT": "Assign an Agent",
      "ADD_LABEL": "Add a Label",
      "REMOVE_LABEL": "Remove a Label",
      "REMOVE_ASSIGNED_AGENT": "Remove Assigned Agent",
      "REMOVE_ASSIGNED_TEAM": "Remove Assigned Team",
      "SEND_EMAIL_TRANSCRIPT": "Send an Email Transcript",
      "MUTE_CONVERSATION": "Gesprek dempen",
      "SNOOZE_CONVERSATION": "Demp gesprek",
      "RESOLVE_CONVERSATION": "Resolve Conversation",
      "SEND_ATTACHMENT": "Send Attachment",
      "SEND_MESSAGE": "Send a Message",
      "CHANGE_PRIORITY": "Change Priority",
      "ADD_PRIVATE_NOTE": "Add a Private Note",
      "SEND_WEBHOOK_EVENT": "Send Webhook Event"
    },
    "PRIORITY_TYPES": {
      "NONE": "Geen",
      "LOW": "Laag",
      "MEDIUM": "Gemiddeld",
      "HIGH": "Hoog",
      "URGENT": "Dringend"
    }
  }
}
